export interface IResourceID {
  id: number;
  name: string;
  legal_name?: string;
  photo_id?: string;
}

type NamedClient = { id: string | number; name: string };

export const buildClientsList = (
  partners: any[],
  userClients: NamedClient[] | undefined,
  storedClients: NamedClient[],
  isSuper: boolean
): IResourceID[] => {
  let baseClientsList: IResourceID[] = [];

  if (partners?.length > 0) {
    baseClientsList = partners
      .map((p: any) => ({
        id: Number(p.id || p.partner_id),
        name: p.name || p.partner_name || p.legal_name || p.display_name,
      }))
      .filter(p => p.id && p.name);
  }

  if (baseClientsList.length === 0 && userClients?.length) {
    baseClientsList = userClients.map(c => ({ id: Number(c.id), name: c.name }));
  }

  if (baseClientsList.length === 0) {
    baseClientsList = storedClients.map(c => ({ id: Number(c.id), name: c.name }));
  }

  return isSuper
    ? [{ id: 0, name: 'ALL' }, ...baseClientsList.filter(c => c.id !== 0)]
    : baseClientsList.filter(c => c.id !== 0);
};
